export default __webpack_public_path__ + "static/media/arras11.bd566ef8.jpg";